import type {
  AuditTrailHistoryTab,
  AuditTrailSortField,
} from '../types/acknowledgementAuditTrail.types';

export type AuditTrailColumnKey =
  | 'accession'
  | 'patient'
  | 'study'
  | 'criticality'
  | 'ackStatus'
  | 'acknowledgedBy'
  | 'escLevel'
  | 'events';

export const AUDIT_TRAIL_COLUMN_LABELS: Record<AuditTrailColumnKey, string> = {
  accession: 'Accession',
  patient: 'Patient',
  study: 'Study',
  criticality: 'Criticality',
  ackStatus: 'Ack status',
  acknowledgedBy: 'Acknowledged by',
  escLevel: 'Esc. level',
  events: 'Events',
};

export const AUDIT_TRAIL_COLUMNS_DEFAULT_VISIBILITY: Record<AuditTrailColumnKey, boolean> = {
  accession: true,
  patient: true,
  study: true,
  criticality: true,
  ackStatus: true,
  acknowledgedBy: true,
  escLevel: true,
  events: true,
};

export const AUDIT_TRAIL_PAGE_SIZE = 20;
export const AUDIT_TRAIL_MAX_PAGE_SIZE = 200;
export const AUDIT_TRAIL_TIMELINE_LIMIT = 500;

export const AUDIT_TRAIL_SORT_FIELDS: AuditTrailSortField[] = [
  'createdAt',
  'acknowledgedAt',
  'notificationStatus',
  'acknowledgementStatus',
  'criticalityBand',
  'orderingClinician',
];

export const AUDIT_TRAIL_ACK_STATUS_OPTIONS = [
  { value: '', label: 'All statuses' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Acknowledged', label: 'Acknowledged' },
  { value: 'Unacknowledged', label: 'Unacknowledged' },
];

export const AUDIT_TRAIL_CRITICALITY_OPTIONS = [
  { value: '', label: 'All bands' },
  { value: 'Major', label: 'Critical-Major' },
  { value: 'Minor', label: 'Critical-Minor' },
];

export const AUDIT_TRAIL_HISTORY_TABS: Array<{ id: AuditTrailHistoryTab; label: string }> = [
  { id: 'auditTimeline', label: 'Audit Timeline' },
  { id: 'notificationHistory', label: 'Notification History' },
  { id: 'acknowledgementHistory', label: 'Acknowledgement History' },
  { id: 'reminderHistory', label: 'Reminder History' },
  { id: 'escalationHistory', label: 'Escalation History' },
  { id: 'deliveryStatus', label: 'Delivery Status' },
];

export const AUDIT_TRAIL_INFO_BANNER =
  'Tamper-evident, read-only log. Every notification, reminder, escalation, delivery outcome and acknowledgement is recorded as an immutable, hash-chained entry.';
